module.exports = __webpack_public_path__ + "img/1.26147c34.jpg";